<script lang="ts">
    import cn from 'classnames';

    import { Font, FontTypes } from '@uikit/font';

    import s from '../styles.module.css';

    export let isBold = false;
    export let classes = '';
    export let testId: string | undefined = undefined;
</script>

<Font
    type={FontTypes.Type.body}
    tagName={FontTypes.TagName.p}
    className={cn(s.text, classes)}
    attrs={testId ? { 'data-testid': testId } : {}}
    {isBold}
>
    <slot />
</Font>
